import { ValidatorFn, Validators } from '@angular/forms';
import { PageSectionFieldValidator } from '../../domain/models/dynamic-form-schema.model';
import {
    atLeastOnePhoneFormValidator,
    computerEquipmentDisallow454CombinedValidator,
    consentTextMessageWhenCellPhoneSelectedFormValidator,
    currentDateValidator,
    eligibilityCategoryValidator,
    eligibilityExplanationValidator,
    emailRequiredValidator,
    futureYearValidator,
    maximumAgeValidator,
    minimumAgeValidator,
    publicAssistanceValidator,
    requireFieldWhenFormValidator
} from './form-validators';

type ValidatorFactory = (
    config: PageSectionFieldValidator
) => ValidatorFn | null;

export const VALIDATOR_REGISTRY: Record<string, ValidatorFactory> = {
    required: () => Validators.required,
    // Must be checked (=== true). Validators.required treats boolean `false` as valid,
    // so it can't enforce an affirmative-consent checkbox. Emits the same `required` error key. (TC-21)
    requiredTrue: () => Validators.requiredTrue,
    email: () => Validators.email,
    emailRequiredForContactPreference: () => emailRequiredValidator,
    minlength: ({ args }) => Validators.minLength(Number(args?.length)),
    maxlength: ({ args }) => Validators.maxLength(Number(args?.length)),
    min: ({ args }) => Validators.min(Number(args?.value)),
    max: ({ args }) => Validators.max(Number(args?.value)),
    pattern: ({ args }) =>
        args?.regex ? Validators.pattern(args.regex) : null,
    futureYear: ({ args }) =>
        futureYearValidator(Number(args?.year) || new Date().getFullYear()),
    minimumAge: ({ args }) => minimumAgeValidator(Number(args?.value)),
    maximumAge: ({ args }) => maximumAgeValidator(Number(args?.value)),
    atLeastOnePhoneRequired: () => atLeastOnePhoneFormValidator,
    consentTextMessageRequired: () =>
        consentTextMessageWhenCellPhoneSelectedFormValidator,
    computerEquipmentDisallow454Combined: () =>
        computerEquipmentDisallow454CombinedValidator,
    currentDate: () => currentDateValidator,
    publicAssistance: () => publicAssistanceValidator,
    eligibilityCategory: () => eligibilityCategoryValidator,
    eligibilityExplanation: () => eligibilityExplanationValidator,
    signatureDate: () => currentDateValidator,
    requireFieldWhen: (config) => requireFieldWhenFormValidator(config)
};

export function createValidatorFromConfig(
    v: PageSectionFieldValidator
): ValidatorFn | null {
    const factory = VALIDATOR_REGISTRY[v.name];
    return factory ? factory(v) : null;
}
